import { Environment, getEnvironment } from './environment';

type Config = {
  env: {
    baseUrl: Environment['baseUrl'];
    name: Environment['name'];
    mode: Environment['mode'];
  };
  restApi: {
    url: Environment['restApiUrl'];
  };
  cmsApi: {
    url: Environment['cmsApiUrl'];
    apiKey: Environment['cmsApiKey'];
  };
  checkout: {
    url: Environment['checkoutUrl'];
  };
  institutional: {
    url: Environment['institutional'];
  };
  searchApi: {
    url: Environment['searchApiUrl'];
  };
};

const environment = getEnvironment();

export const config: Config = {
  env: {
    name: environment.name,
    baseUrl: environment.baseUrl,
    mode: environment.mode,
  },
  restApi: {
    url: environment.restApiUrl,
  },
  cmsApi: {
    url: environment.cmsApiUrl,
    apiKey: environment.cmsApiKey,
  },
  checkout: {
    url: environment.checkoutUrl,
  },
  institutional: {
    url: environment.institutional,
  },
  searchApi: {
    url: environment.searchApiUrl,
  },
};
